@if (config.type == 'dropdown') {
<div
  ngbDropdown
  [container]="config.dropdownContainer"
  placement="bottom-end"
  class="d-inline-block dropdown-custom"
>
  <button-component
    type="button"
    id="dropdownBasic1"
    ngbDropdownToggle
    [config]="config.customBtn!"
  />

  <div ngbDropdownMenu aria-labelledby="dropdownBasic1" class="shadow-sm">
    @for (action of config.actions; track action) {
    <button
      ngbDropdownItem
      (click)="action.action!(data)"
      class="d-flex gap-2 align-items-center"
    >
      <icon [icon]="action.icon" size="17" color="primary" />
      {{ action.label | translate }}
    </button>
    }
  </div>
</div>
} @else if (config.type == 'searchBox') {
<div
  ngbDropdown
  #myDrop="ngbDropdown"
  [container]="config.dropdownContainer"
  placement="bottom-end"
  class="d-inline-block dropdown-custom w-100"
>
  <text-input-component
    [config]="config.config.input"
    (onFormFieldChange)="filterData($event)"
  />

  <div
    ngbDropdownMenu
    aria-labelledby="dropdownBasic1"
    class="shadow-sm w-100 mt-2 overflow-y-auto"
    style="max-height: 45vh;"
  >
    @if(filteredData){ @if(filteredData.length > 0){ @for (data of filteredData;
    track data) {
    <button
      ngbDropdownItem
      class="d-flex gap-2 align-items-center"
      (click)="handleSelectedData(data);"
    >
      {{ getOptionLabel(data) }}
    </button>
    } } @else {
    <div class="d-flex flex-column align-items-center gap-2 py-2">
      <div class="p-3 bg-info-light rounded-circle">
        <icon [icon]="icons.search" size="18" color="info-dark" />
      </div>

      <div class="d-flex flex-column text-center fs-9">
        <span class="fw-semibold">{{ 'common.dropdown.searchbox.state.no-results.title' | translate}}</span>
        <span class="text-info">{{ 'common.dropdown.searchbox.state.no-results.description' | translate }}</span>
      </div>
    </div>

    } } @else {
    <div class="d-flex flex-column align-items-center py-2">
      <icon [icon]="icons.spinner" size="50" [color]="'primary'" />

      <div class="d-flex flex-column text-center fs-9">
        <span class="text-info">{{ 'common.dropdown.searchbox.state.searching' | translate }}</span>
      </div>
    </div>
    }
  </div>
</div>
}
